import React, { Fragment, useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Modal from '@tds/community-modal';

import { Error } from '../design/elements';
import FormField from './formField';
import {
  EquipmentSectionWrapper,
  EquipmentSectionTitle,
  EquipmentSectionSubTitle
} from './css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import stringInterpolation from '../utils/stringInterpolation';
import { getFieldValue } from './utils';
import {
  cameraTypeList,
  typePoeCamera,
  keyMonitorAdditionalEquipment,
  keySecurityCameraEquipment,
  typeSwitch,
  keyProtectAdditionalEquipment,
  keyControlAdditionalEquipment,
  keyProtectIncludedEquipmentSelection,
  keyControlIncludedEquipmentSelection,
  secureBusinessOppositeSectionKeys,
  secureBusinessMaxCameraLimit,
  poeSwitchZero,
  poeSwitchNonZero,
  easyPoeSwitchZero,
  easyPoeSwitchNonZero,
  poeSwitchIncludedEquipment,
  fieldPoeSwitchZero,
  fieldPoeSwitchNonZero,
  fieldPoeSwitchIncludedEquipment,
  fieldEasyPoeSwitchZero,
  fieldEasyPoeSwitchNonZero,
  oneTimePaymentFields,
  hasQuebecServiceAddress,
  poeTurretCamera,
  easyPoeTurret,
  poeDomeCamera,
  temperatureSensor,
  temperatureProbe,
  easyTemperatureSensor,
  easyTemperatureProbe,
  easyPoeDome,
  poeTurretCameraFree,
  poeDomeCameraFree,
  easyFiveYearTemperatureSensor,
  fieldEasyFiveYearFivePortPoeSwitch,
  fieldEasyFiveYearFivePortPoeSwitchPaid,
  easyFiveYearTemperatureProbe,
  indoorCameraFree,
  outdoorCameraFree,
  indoorCamera,
  outdoorCamera,
  easyFiveYearOutdoorCamera,
  easyFiveYearIndoorCamera,
  easyIndoorCamera,
  easyOutdoorCamera,
  controlIncludedSdCard,
  controlIncludedPaid2TbSvr,
  microSdCard128Gb,
  easyMicroSdCard128Gb,
  easyFiveYearMicroSdCard128Gb,
  controlIncludedCameraLimit,
  svr2Tb,
  easySvr2Tb,
  easyFiveYearTwoTbSVR,
  easyFiveYearPoeTurretCamera,
} from '../utils/constant';
import { useHistory } from 'react-router-dom';

const EquipmentSectionForm = ({
  data,
  formErrors,
  formFields,
  setFormFields,
  isFormTouched,
  setIsFormTouched,
  equipmentTotalPrice,
  setEquipmentTotalPrice,
  hardwareDiscountAmount,
  setHadwareDiscountAmount,
  dueNow,
  setDueNow,
  isHardwareDiscount,
  orderData,
  renderTempSensor,
  setRenderTempSensor
}) => {
 
  const [isAlert, setIsAlertOpen] = useState(false)
  const [bodyText,setBodyText]=useState('');

  const [tempSensorPrice,setTempSensorPrice]= useState({
    temperatureMonitoringFiveDollar:0,
    temperatureMonitoringTenDollar:0
});

  const {
    name,
    title,
    subTitle,
    maxValue,
    isLimitCameraOnly,
    formStepFields,
    oneTimePaymentTitle,
    easyPaymentTitle,
    easyPaymentFields,
    fiveYearEasyPaymentFields,
    fiveYearEasyPaymentTitle
  } = data;
  let finalFields;
  if (Array.isArray(formStepFields) && Array.isArray(easyPaymentFields) && Array.isArray(fiveYearEasyPaymentFields)) {
    finalFields = [...formStepFields, ...easyPaymentFields, ...fiveYearEasyPaymentFields];
  } else {
    finalFields = formStepFields;
  }
  const localizedStrings = useLocalizedStringsContext();
  const {
    fieldPlusMinus: { errorMessage },
    secureBusiness: { maxCameraLimitErrorMessage }
  } = localizedStrings;

  const checkIfHasSwitchOption = () => {
    const isSwitch =
      formFields[name] &&
      (Object.prototype.hasOwnProperty.call(formFields[name], fieldPoeSwitchZero) ||
        Object.prototype.hasOwnProperty.call(formFields[name], fieldPoeSwitchNonZero) ||
        Object.prototype.hasOwnProperty.call(formFields[name], fieldPoeSwitchIncludedEquipment) ||
        Object.prototype.hasOwnProperty.call(formFields[name], temperatureProbe) ||
        Object.prototype.hasOwnProperty.call(formFields[name], fieldEasyPoeSwitchZero) ||
        Object.prototype.hasOwnProperty.call(formFields[name], fieldEasyPoeSwitchNonZero) ||
        Object.prototype.hasOwnProperty.call(formFields[name], easyTemperatureProbe) ||
        Object.prototype.hasOwnProperty.call(formFields[name], fieldEasyFiveYearFivePortPoeSwitch) ||
        Object.prototype.hasOwnProperty.call(formFields[name], fieldEasyFiveYearFivePortPoeSwitchPaid) ||
        Object.prototype.hasOwnProperty.call(formFields[name], easyFiveYearTemperatureProbe)
      );
    return isSwitch;
  };

  const formObjectKeys = useMemo(
    () =>
      finalFields.reduce((acc, { fields: { name: formName } }) => {
        acc.push(formName);
        return acc;
      }, []),
    [formStepFields]
  );  
  useEffect(() => {
    // Calc initial prices
    const fields = { ...formFields[name] } || {};
    if (fields) {
      const sumForSection = formObjectKeys
        .filter(kf => (fields[kf] || {}).isVisible)
        .reduce((acc, kn) => {
          const val =
            parseInt((fields[kn] || {}).value || 0, 10) *
            (fields[kn] || {}).price || 0;
          return acc + val;
        }, 0);
      const sumForMonthly = formObjectKeys
        .filter(kf => (fields[kf] || {}).isVisible)
        .reduce((acc, kn) => {
          const val =
            parseInt((fields[kn] || {}).value || 0, 10) *
            (fields[kn] || {}).monthlyPayment || 0;
          return acc + val;
        }, 0);

        const sumForFiveYearMonthly = formObjectKeys
        .filter(kf => (fields[kf] || {}).isVisible)
        .reduce((acc, kn) => {
          const val =
            parseInt((fields[kn] || {}).value || 0, 10) *
            (fields[kn] || {}).fiveYearEasyPayment || 0;
          return acc + val;
        }, 0);

      const currentPrice = equipmentTotalPrice.addAmountToPrice;
      const newPrice = currentPrice + sumForSection;
      const currentMonthlyPayment = equipmentTotalPrice.addAmountToMonthly;
      let newMonthlyPayment = currentMonthlyPayment + sumForMonthly ;
      const currentFiveYearMonthly = equipmentTotalPrice.addAmountToFiveYearMonthly;
      const newFiveYearMonthly = currentFiveYearMonthly + sumForFiveYearMonthly ;
      //SOF-1768
      const valueTempSensor = getFieldValue(
        temperatureSensor,
        fields
      );
      if (valueTempSensor > 0) {
        newMonthlyPayment += 5
      }
      if (valueTempSensor > 5) {
        newMonthlyPayment += 5
      }
      const valueEasyTempSensor = getFieldValue(
        easyTemperatureSensor,
        fields
      );
      if (valueEasyTempSensor > 0) {
        newMonthlyPayment += 5
      }
      if (valueEasyTempSensor > 5) {
        newMonthlyPayment += 5
      }
      if (valueTempSensor > 0 && valueEasyTempSensor > 0) {
        newMonthlyPayment -= 5
      }
      ///////
      if (
        [
          keyControlAdditionalEquipment,
          keyProtectAdditionalEquipment,
          keyMonitorAdditionalEquipment
        ].includes(name)
      ) {
        let discountAmount = 0;
        if (newPrice >= 200) {
          discountAmount = 200;
        } else if (newPrice > 0) {
          discountAmount = newPrice;
        }
        if (isHardwareDiscount) setDueNow(dueNow + hardwareDiscountAmount);
        setHadwareDiscountAmount(discountAmount);
      }
      setEquipmentTotalPrice({
        subtractAmountFromPrice: currentPrice,
        addAmountToPrice: newPrice,
        subtractAmountFromMonthly: currentMonthlyPayment,
        addAmountToMonthly: newMonthlyPayment ,
        addAmountToFiveYearMonthly : newFiveYearMonthly,
        subtractAmountFromFiveYearMonthly : currentFiveYearMonthly
      });
    }
  }, []);

  const checkIfTotalOverLimit = (opt, fieldProductType) => {
    const returnObj = {
      totalOverLimit: false,
      isCameraLimit: false
    };

    if (
      [
        keyProtectIncludedEquipmentSelection,
        keyProtectAdditionalEquipment,
        keyControlIncludedEquipmentSelection,
        keyControlAdditionalEquipment,
        keyMonitorAdditionalEquipment
      ].includes(name) &&
      cameraTypeList.includes(fieldProductType)
    ) {
      const otherSectionKey = secureBusinessOppositeSectionKeys[name];
      const otherSection = { ...formFields[otherSectionKey] };
      const otherSectionSum = Object.keys(otherSection)
        .filter(ko =>
          cameraTypeList.includes((otherSection[ko] || {}).productType)
        )
        .reduce(
          (acc, ko) => acc + parseInt(otherSection[ko].value || 0, 10),
          0
        );
      const currentSum = formObjectKeys
        .filter(key => cameraTypeList.includes(opt[key].productType))
        .reduce((acc, key) => acc + parseInt(opt[key].value || 0, 10), 0);
      if (otherSectionSum + currentSum > secureBusinessMaxCameraLimit) {
        returnObj.totalOverLimit = true;
        returnObj.isCameraLimit = true;
        const text = stringInterpolation(
          returnObj.isCameraLimit ? maxCameraLimitErrorMessage : errorMessage,
          returnObj.isCameraLimit ? secureBusinessMaxCameraLimit : maxValue
        )
        setIsAlertOpen(true)
        setBodyText(text)
        return returnObj
      } else if (
        [
          keyProtectIncludedEquipmentSelection,
          keyControlIncludedEquipmentSelection
        ].includes(name) &&
        typeof maxValue === 'number'
      ) {
        const sectionSum = formObjectKeys
          .filter(k => opt[k].productType !== typeSwitch)
          .reduce((acc, k) => acc + parseInt(opt[k].value || 0, 10), 0);
        if (sectionSum > maxValue) {
          returnObj.totalOverLimit = true;
          returnObj.isCameraLimit = false;
          const text = stringInterpolation(
            returnObj.isCameraLimit ? maxCameraLimitErrorMessage : errorMessage,
            returnObj.isCameraLimit ? secureBusinessMaxCameraLimit : maxValue
          )
          setIsAlertOpen(true)
          setBodyText(text)
          return returnObj
        }
      }
    } else if (typeof maxValue === 'number' && !isLimitCameraOnly) {
      const currentSum = formObjectKeys
        .filter(k => opt[k].productType !== typeSwitch)
        .reduce((acc, k) => acc + parseInt(opt[k].value || 0, 10), 0);
      if (currentSum > maxValue) {
        returnObj.totalOverLimit = true;
        returnObj.isCameraLimit = false;
        const text = stringInterpolation(
          returnObj.isCameraLimit ? maxCameraLimitErrorMessage : errorMessage,
          returnObj.isCameraLimit ? secureBusinessMaxCameraLimit : maxValue
        )
        setIsAlertOpen(true)
        setBodyText(text)
        return returnObj
      }
    }
    if (
      [
        keyProtectAdditionalEquipment,
        keyControlAdditionalEquipment,
        keyMonitorAdditionalEquipment
      ].includes(name) && fieldProductType === 'Probe') {
      const otherSectionKey = secureBusinessOppositeSectionKeys[name];
      const otherSection = { ...formFields[otherSectionKey] };
      const otherSectionSum = Object.keys(otherSection)
        .filter(ko =>
          'Probe'.includes((otherSection[ko] || {}).productType)
        )
        .reduce(
          (acc, ko) => acc + parseInt(otherSection[ko].value || 0, 10),
          0
        );
      const currentSum = formObjectKeys
        .filter(key => 'Probe'.includes(opt[key].productType))
        .reduce((acc, key) => acc + parseInt(opt[key].value || 0, 10), 0);
      if (otherSectionSum + currentSum > 10) {
        returnObj.totalOverLimit = true;
        returnObj.isCameraLimit = true;
        const text = stringInterpolation(
          "A maximum of %s temerature sensors can be selected in total",
          10
        )
        setIsAlertOpen(true);
        setBodyText(text);
        return returnObj;
      }
    }

    return returnObj;
  };
  const getControlIncludedCameraTotal = (opt, fieldProductType) => {
    const returnObj = {
      controlIncludedCameraTotalOverLimit: false,
      isControlCameraLimit: false
    };

    if (
      [keyControlIncludedEquipmentSelection].includes(name) &&
      cameraTypeList.includes(fieldProductType)
    ) { 
      const sectionSum = formObjectKeys
        .filter(k => cameraTypeList.includes(opt[k].productType))
        .reduce((acc, k) => acc + parseInt(opt[k].value || 0, 10), 0);
      if (sectionSum > 2) {
        returnObj.controlIncludedCameraTotalOverLimit = true;
        const text = stringInterpolation(
          returnObj.isControlCameraLimit
            ? maxCameraLimitErrorMessage
            : errorMessage,
          returnObj.isControlCameraLimit
            ? secureBusinessMaxCameraLimit
            : controlIncludedCameraLimit
        );
        setIsAlertOpen(true);
        setBodyText(text);
        return returnObj;
      }
    }
    return returnObj; // Ensure returnObj is always returned
  };

  const getCameraTotal = (fieldProductType, overallCount, easyCount, oneTimeCount) => {
    let count = 0
    if (
      [
        keyProtectIncludedEquipmentSelection,
        keyProtectAdditionalEquipment,
        keyControlIncludedEquipmentSelection,
        keyControlAdditionalEquipment
      ].includes(name) &&
      typePoeCamera.includes(fieldProductType)
    ) {
      const otherSectionKey = secureBusinessOppositeSectionKeys[name];
      const otherSection = { ...formFields[otherSectionKey] };
      if (overallCount) {
        const paymentSectionSum = Object.keys(otherSection)
          .filter(ko => {
            return typePoeCamera === ((otherSection[ko] || {}).productType)
          })
          .reduce(
            (acc, ko) => acc + parseInt(otherSection[ko].value || 0, 10),
            0
          );
        count = paymentSectionSum;
      }
      if (easyCount) {
        const paymentSectionSum = Object.keys(otherSection)
          .filter(ko => {
            return typePoeCamera === ((otherSection[ko] || {}).productType) &&
              ko.includes('easy');
          })
          .reduce(
            (acc, ko) => acc + parseInt(otherSection[ko].value || 0, 10),
            0
          );
        count = paymentSectionSum;
      }
      if (oneTimeCount) {
        const paymentSectionSum = Object.keys(otherSection)
          .filter(ko => {
            return typePoeCamera === ((otherSection[ko] || {}).productType) &&
              !ko.includes('easy');
          })
          .reduce(
            (acc, ko) => acc + parseInt(otherSection[ko].value || 0, 10),
            0
          );
        count = paymentSectionSum;
      }

    }
    return count;
  }

  const calculateEquipmentRates = (oldValues, newValues, fieldName,oldFields,newFields) => {
    const radioSelection = name.slice(0, 7);
    let calculationKeys = formObjectKeys;
    if (radioSelection === 'control') {
        oldValues = {...oldFields[keyControlAdditionalEquipment],...oldFields[keyControlIncludedEquipmentSelection]}
        newValues = {...newFields[keyControlAdditionalEquipment],...newFields[keyControlIncludedEquipmentSelection]}
        const pricingFields = [keyControlAdditionalEquipment,keyControlIncludedEquipmentSelection]
        const addedFields = new Set([]);

        if (oldFields) {
            pricingFields.forEach(section => {
            const sectionFields = oldFields[section];
            if (sectionFields) {
              Object.values(sectionFields).forEach(field => {
                if (field.name && !addedFields.has(field.name)) {
                  pricingFields.push(field.name);
                  addedFields.add(field.name);
                }
              });
            }
          });
        }
        calculationKeys = addedFields;
    }
    
    const oldSumForSection = calculationKeys.reduce(
      (acc, ko) =>
        acc + parseInt(oldValues[ko].value || 0, 10) * oldValues[ko].price || 0,
      0
    );
    const newSumForSection = calculationKeys.reduce(
      (acc, kn) =>
        acc + parseInt(newValues[kn].value || 0, 10) * newValues[kn].price || 0,
      0
    );
 
    const newSumForDueMonthly = calculationKeys.reduce(
      (acc, kn) =>
        acc +
        parseInt(newValues[kn].value || 0, 10) * newValues[kn].monthlyPayment || 0,
      0
    );
    const oldSumForDueMonthly = calculationKeys.reduce(
      (acc, kn) =>
        acc +
        parseInt(oldValues[kn].value || 0, 10) * oldValues[kn].monthlyPayment || 0,
      0
    );

    // Calculating Five Year Pricing
    const newSumForDueMonthlyFiveYear = calculationKeys.reduce(
        (acc, kn) =>
          acc +
          parseInt(newValues[kn].value || 0, 10) * newValues[kn].fiveYearEasyPayment || 0,
        0
      );
      const oldSumForDueMonthlyFiveYear = calculationKeys.reduce(
        (acc, kn) =>
          acc +
          parseInt(oldValues[kn].value || 0, 10) * oldValues[kn].fiveYearEasyPayment || 0,
        0
      );
     
    const currentPrice = equipmentTotalPrice.addAmountToPrice;
    const newPrice = currentPrice + (newSumForSection - oldSumForSection);
    const currentMonthlyPayment = equipmentTotalPrice.addAmountToMonthly || 0;
    let newMonthlyPayment =
      currentMonthlyPayment + (newSumForDueMonthly - oldSumForDueMonthly);
    // Five Year Payment Calculation
    const currentFiveYearMonthlyPayment = equipmentTotalPrice.addAmountToFiveYearMonthly || 0;
    let newFiveYearMonthlyPayment =
    currentFiveYearMonthlyPayment + (newSumForDueMonthlyFiveYear - oldSumForDueMonthlyFiveYear);
    if (
        [
            keyProtectAdditionalEquipment,
            keyControlAdditionalEquipment,
            keyMonitorAdditionalEquipment
        ].includes(name)) {
        // Temperature Sensor Pricing
    
        // Helper function to get the value, ensuring it's not undefined
        const getValue = (obj, field) => {
            if (obj && obj.hasOwnProperty(field) && obj[field] && obj[field].value) {
              return obj[field].value;
            }
            return 0;
          };
    
        const oldTempSensor = getValue(oldValues, 'temperatureSensor');
        const oldEasyTempSensor = getValue(oldValues, 'easyTemperatureSensor');
        const oldEasyFiveYearTempSensor = getValue(oldValues, 'easyFiveYearTemperatureSensor');
    
        const newTempSensor = getValue(newValues, 'temperatureSensor');
        const newEasyTempSensor = getValue(newValues, 'easyTemperatureSensor');
        const newEasyFiveYearTempSensor = getValue(newValues, 'easyFiveYearTemperatureSensor');
    
        // Handling temperatureSensor field
        if ((fieldName === 'temperatureSensor') && (newEasyTempSensor === 0) && (newEasyFiveYearTempSensor === 0)) {
            // increase
            if (newTempSensor > oldTempSensor) {
                if (newTempSensor === 1 || newTempSensor === 6) {
                    newMonthlyPayment += 5;
                }
            } 
            // decrease
            else if (newTempSensor < oldTempSensor) {
                if (newTempSensor === 0 || newTempSensor === 5) {
                    newMonthlyPayment -= 5;
                }
            }
        }
        // Handling easyTemperatureSensor field
        else if ((fieldName === 'easyTemperatureSensor') && (newTempSensor === 0) && (newEasyFiveYearTempSensor === 0)) {
            // increase
            if (newEasyTempSensor > oldEasyTempSensor) {
                if (newEasyTempSensor === 1 || newEasyTempSensor === 6) {
                    newMonthlyPayment += 5;
                }
            } 
            // decrease
            else if (newEasyTempSensor < oldEasyTempSensor) {
                if (newEasyTempSensor === 0 || newEasyTempSensor === 5) {
                    newMonthlyPayment -= 5;
                }
            }
        }
        // Handling easyFiveYearTemperatureSensor field
        else if ((fieldName === 'easyFiveYearTemperatureSensor') && (newTempSensor === 0) && (newEasyTempSensor === 0)) {
            // increase
            if (newEasyFiveYearTempSensor > oldEasyFiveYearTempSensor) {
                if (newEasyFiveYearTempSensor === 1 || newEasyFiveYearTempSensor === 6) {
                    newMonthlyPayment += 5;
                }
            } 
            // decrease
            else if (newEasyFiveYearTempSensor < oldEasyFiveYearTempSensor) {
                if (newEasyFiveYearTempSensor === 0 || newEasyFiveYearTempSensor === 5) {
                    newMonthlyPayment -= 5;
                }
            }
        }
        // Handling any combination of the three fields
        else if (
            (fieldName === 'easyTemperatureSensor' && (newTempSensor !== 0 || newEasyFiveYearTempSensor !== 0)) ||
            (fieldName === 'temperatureSensor' && (newEasyTempSensor !== 0 || newEasyFiveYearTempSensor !== 0)) ||
            (fieldName === 'easyFiveYearTemperatureSensor' && (newTempSensor !== 0 || newEasyTempSensor !== 0))) {
            
            if (fieldName === 'temperatureSensor' || fieldName === 'easyTemperatureSensor' || fieldName === 'easyFiveYearTemperatureSensor') {
                const oldTotal = oldTempSensor + oldEasyTempSensor + oldEasyFiveYearTempSensor;
                const newTotal = newTempSensor + newEasyTempSensor + newEasyFiveYearTempSensor;
    
                // increase
                if (newTotal > oldTotal) {
                    if (newTotal === 1 || newTotal === 6) {
                        newMonthlyPayment += 5;
                    }
                } 
                // decrease
                else if (newTotal < oldTotal) {
                    if (newTotal === 0 || newTotal === 5) {
                        newMonthlyPayment -= 5;
                    }
                }
            }
        }
    }
    
    

    if (
      [
        keyControlAdditionalEquipment,
        keyProtectAdditionalEquipment,
        keyMonitorAdditionalEquipment
      ].includes(name)
    ) {
      let discountAmount = 0;
      if (newPrice >= 200) {
        discountAmount = 200;
      } else if (newPrice > 0) {
        discountAmount = newPrice;
      }
      if (isHardwareDiscount) setDueNow(dueNow + hardwareDiscountAmount);
      setHadwareDiscountAmount(discountAmount);
    }
    setEquipmentTotalPrice({
      subtractAmountFromPrice: currentPrice || 0,
      addAmountToPrice: newPrice || 0,
      addAmountToMonthly: newMonthlyPayment || 0,
      subtractAmountFromMonthly: currentMonthlyPayment  || 0,
      addAmountToFiveYearMonthly : newFiveYearMonthlyPayment || 0,
      subtractAmountFromFiveYearMonthly : currentFiveYearMonthlyPayment || 0
    });
  };

  // Function to calculate temperature sensors based on key names
  const countTemperatureSensorAll = inputKeys => {
    let tempSensorCount = 0;
    const radioSelection = name.slice(0, 7);

    const getValue = (keyPath, sensorKey) => {
      if (
        formFields[keyPath] &&
        formFields[keyPath][sensorKey] &&
        formFields[keyPath][sensorKey].value !== undefined
      ) {
        return formFields[keyPath][sensorKey].value;
      }
      return 0;
    };

    // Ensure inputKeys is an array
    let keys = [];
    if (Array.isArray(inputKeys)) {
      keys = inputKeys;
    } else if (typeof inputKeys === 'string') {
      keys = [inputKeys];
    }

    keys.forEach(key => {
      if (radioSelection === 'monitor') {
        if (key === 'oneTimePayment') {
          tempSensorCount += getValue(
            keyMonitorAdditionalEquipment,
            temperatureSensor
          );
        }
        if (key === 'easy') {
          tempSensorCount += getValue(
            keyMonitorAdditionalEquipment,
            easyTemperatureSensor
          );
        }
        if (key === 'fiveYearEasyPayment') {
          tempSensorCount += getValue(
            keyMonitorAdditionalEquipment,
            easyFiveYearTemperatureSensor
          );
        }
      }

      if (radioSelection === 'protect') {
        if (key === 'oneTimePayment') {
          tempSensorCount += getValue(
            keyProtectAdditionalEquipment,
            temperatureSensor
          );
        }
        if (key === 'easy') {
          tempSensorCount += getValue(
            keyProtectAdditionalEquipment,
            easyTemperatureSensor
          );
        }
        if (key === 'fiveYearEasyPayment') {
          tempSensorCount += getValue(
            keyProtectAdditionalEquipment,
            easyFiveYearTemperatureSensor
          );
        }
      }

      if (radioSelection === 'control') {
        if (key === 'oneTimePayment') {
          tempSensorCount += getValue(
            keyControlAdditionalEquipment,
            temperatureSensor
          );
        }
        if (key === 'easy') {
          tempSensorCount += getValue(
            keyControlAdditionalEquipment,
            easyTemperatureSensor
          );
        }
        if (key === 'fiveYearEasyPayment') {
          tempSensorCount += getValue(
            keyControlAdditionalEquipment,
            easyFiveYearTemperatureSensor
          );
        }
      }
    });
    return tempSensorCount;
  };



  const [temperatureSensorCountAll, setTemperatureSensorCountAll] = useState(0);
  useEffect(() => {
    setTemperatureSensorCountAll(
      countTemperatureSensorAll([
        'oneTimePayment',
        'easy',
        'fiveYearEasyPayment'
      ])
    );
  }, [formFields]);

  useEffect(() => {
    // Logic to update form fields based on the temperatureSensorCountAll
    const fields = { ...formFields };
    if(fields && (fields[keyMonitorAdditionalEquipment] || fields[keyControlAdditionalEquipment] || fields[keyProtectAdditionalEquipment])){
        if (
      temperatureSensorCountAll < 1 ||
      temperatureSensorCountAll === undefined
    ) {
      const radioSelection = name.slice(0, 7);

      if (radioSelection === 'monitor') {
        setTempSensorPrice({
            temperatureMonitoringFiveDollar:0,
            temperatureMonitoringTenDollar:0
        })
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringFiveDollar.isVisible = false;
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringTenDollar.isVisible = false;
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringFiveDollar.value = 0;
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringTenDollar.value = 0;
      }
      if (radioSelection === 'protect') {
        setTempSensorPrice({
            temperatureMonitoringFiveDollar:0,
            temperatureMonitoringTenDollar:0
        });
        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringFiveDollar.isVisible = false;

        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringTenDollar.isVisible = false;
        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringFiveDollar.value = 0;
        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringTenDollar.value = 0;
      }
      if (radioSelection === 'control') {
        setTempSensorPrice({
            temperatureMonitoringFiveDollar:0,
            temperatureMonitoringTenDollar:0
        });
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringFiveDollar.isVisible = false;
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringTenDollar.isVisible = false;
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringFiveDollar.value = 0;
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringTenDollar.value = 0;
      }
    } else if (temperatureSensorCountAll < 6) {
      const radioSelection = name.slice(0, 7);

      if (radioSelection === 'monitor') {
        setTempSensorPrice({
            temperatureMonitoringFiveDollar:5,
            temperatureMonitoringTenDollar:0
        });
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringFiveDollar.isVisible = true;
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringTenDollar.isVisible = false;
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringFiveDollar.value = 1;
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringTenDollar.value = 0;
      }
      if (radioSelection === 'protect') {
        setTempSensorPrice({
            temperatureMonitoringFiveDollar:5,
            temperatureMonitoringTenDollar:0
        });
        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringFiveDollar.isVisible = true;

        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringTenDollar.isVisible = false;
        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringFiveDollar.value = 1;
        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringTenDollar.value = 0;
      }
      if (radioSelection === 'control') {
        setTempSensorPrice({
            temperatureMonitoringFiveDollar:5,
            temperatureMonitoringTenDollar:0
        });
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringFiveDollar.isVisible = true;
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringTenDollar.isVisible = false;
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringFiveDollar.value = 1;
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringTenDollar.value = 0;
      }
    } else if (temperatureSensorCountAll > 5) {
      const radioSelection = name.slice(0, 7);

      if (radioSelection === 'monitor') {
        setTempSensorPrice({
            temperatureMonitoringFiveDollar:5,
            temperatureMonitoringTenDollar:5
        });
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringFiveDollar.isVisible = false;
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringTenDollar.isVisible = true;
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringFiveDollar.value = 0;
        fields[
          keyMonitorAdditionalEquipment
        ].temperatureMonitoringTenDollar.value = 1;
      }
      if (radioSelection === 'protect') {
        setTempSensorPrice({
            temperatureMonitoringFiveDollar:5,
            temperatureMonitoringTenDollar:5
        });
        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringFiveDollar.isVisible = false;

        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringTenDollar.isVisible = true;
        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringFiveDollar.value = 0;
        fields[
          keyProtectAdditionalEquipment
        ].temperatureMonitoringTenDollar.value = 1;
      }
      if (radioSelection === 'control') {
        setTempSensorPrice({
            temperatureMonitoringFiveDollar:5,
            temperatureMonitoringTenDollar:5
        });
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringFiveDollar.isVisible = false;
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringTenDollar.isVisible = true;
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringFiveDollar.value = 0;
        fields[
          keyControlAdditionalEquipment
        ].temperatureMonitoringTenDollar.value = 1;
      }
    }
}
    setRenderTempSensor(!renderTempSensor);
  }, [temperatureSensorCountAll]);

  const handleFormField = ({ name: fieldName, value }) => {
    // below fields will be inactive, can't add/remove manually
    if (
        [
          controlIncludedSdCard,
  
          microSdCard128Gb,
          easyMicroSdCard128Gb,
          easyFiveYearMicroSdCard128Gb,
          temperatureProbe,
          temperatureProbe,
          easyTemperatureProbe,
          easyFiveYearTemperatureProbe,
          controlIncludedPaid2TbSvr
        ].includes(fieldName)
      ) {
        return null;
      }

    const checkAllPoeCameraValues = () => {
      const radioSelection = name.slice(0, 7);
      if (radioSelection === 'protect') {
        if (
          fields[keyProtectIncludedEquipmentSelection].poeTurretCameraFree.value > 0 ||
          fields[keyProtectAdditionalEquipment].poeTurretCamera.value > 0 ||
          fields[keyProtectAdditionalEquipment].easyPoeTurret.value > 0 ||
          fields[keyProtectAdditionalEquipment].easyFiveYearPoeTurretCamera.value > 0
        ) {
          return true;
        } else return false;
      }
      if (radioSelection === 'control') {
        if (
          fields[keyControlIncludedEquipmentSelection].poeTurretCameraFree.value > 0 ||
          fields[keyControlAdditionalEquipment].poeTurretCamera.value > 0 ||
          fields[keyControlAdditionalEquipment].easyPoeTurret.value > 0 ||
          fields[keyControlAdditionalEquipment].easyFiveYearPoeTurretCamera.value > 0
        ) {
          return true;
        } else return false;
      }
    }

    let poeCameraCountAll = 0;

    const fields = _.cloneDeep(formFields);
    const oldFields = _.cloneDeep(formFields);
    const oldValues = _.cloneDeep(formFields[name]);
    fields[name][fieldName] = {
      ...fields[name][fieldName],
      value: parseInt(value, 10)
    };

    const countAllPoeCamera = () =>
        {
          const radioSelection = name.slice(0, 7);
      const keys = ['oneTimePayment','easy','easyFiveYearPayment']
          const getValue = (keyPath, poeCameraKey) => {
            if (
              fields[keyPath] &&
              fields[keyPath][poeCameraKey] &&
              fields[keyPath][poeCameraKey].value !== undefined
            ) {
              return fields[keyPath][poeCameraKey].value;
            }
            return 0;
          };
      
          keys.forEach(key => {
              if (radioSelection === 'control') {
                if (key === 'oneTimePayment') {
                  poeCameraCountAll += getValue(
                    keyControlAdditionalEquipment,
                    poeTurretCamera
                  );
                  poeCameraCountAll += getValue(
                      keyControlIncludedEquipmentSelection,
                      poeTurretCameraFree
                    );
                }
                if (key === 'easy') {
                  poeCameraCountAll += getValue(
                    keyControlAdditionalEquipment,
                    easyPoeTurret
                  );
                }
                if (key === 'easyFiveYearPayment') {
                  poeCameraCountAll += getValue(
                    keyControlAdditionalEquipment,
                    easyFiveYearPoeTurretCamera
                  );
                }
              }
            });
            return poeCameraCountAll;
        }
        poeCameraCountAll = countAllPoeCamera();

        const setSdCard = fields => {
            const controlIncludedPoeTurretCameraValue =
              fields[keyControlIncludedEquipmentSelection].controlIncludedPaid2TbSvr
                .value;
            const radioSelection = name.slice(0, 7);
      
            if (radioSelection === 'control') {
              const cameraSum =
                parseInt(
                  fields[keyControlIncludedEquipmentSelection].indoorCameraFree
                    .value || 0,
                  10
                ) +
                parseInt(
                  fields[keyControlIncludedEquipmentSelection].outdoorCameraFree
                    .value || 0,
                  10
                );
              if (cameraSum > 0 && !(controlIncludedPoeTurretCameraValue >= 1)) {
                fields[
                  keyControlIncludedEquipmentSelection
                ].controlIncludedSdCard.value = cameraSum;
              } else if (
                cameraSum === 0 ||
                controlIncludedPoeTurretCameraValue >= 1
              ) {
                fields[
                  keyControlIncludedEquipmentSelection
                ].controlIncludedSdCard.value = 0;
              }
            }
      
            return fields;
          };
    const fieldProductType = fields[name][fieldName].productType;
    const {
        controlIncludedCameraTotalOverLimit,
        isControlCameraLimit
      } = getControlIncludedCameraTotal(fields[name], fieldProductType);
    const { totalOverLimit, isCameraLimit } = checkIfTotalOverLimit(
      fields[name],
      fieldProductType
    );
    if (!totalOverLimit && !controlIncludedCameraTotalOverLimit) {
      if (!isFormTouched) {
        setIsFormTouched(true);
      }
      if (checkIfHasSwitchOption() && !fieldName.startsWith('easy')) {
        const poeCameraCount = formObjectKeys
          .filter(
            kc =>
              fields[name][kc].productType === typePoeCamera &&
              !kc.startsWith('easy')
          )
          .reduce(
            (acc, kc) => acc + parseInt(fields[name][kc].value || 0, 10),
            0
          );
        const switchKey = formObjectKeys.filter(
          k => {
            return (fields[name][k].productType === typeSwitch &&
              fields[name][k].name === poeSwitchZero)
          });
        if (switchKey.length > 0) {
          for (let i = 0; i < switchKey.length; i++) {
            fields[name][switchKey[i]].isVisible = poeCameraCount > 0;
            fields[name][switchKey[i]].value = poeCameraCount > 0 ? 1 : 0;
        }
        fields[keyControlIncludedEquipmentSelection][controlIncludedPaid2TbSvr].value = poeCameraCountAll > 0 ? 1 : 0;
            setSdCard(fields);

        }
        const includedSwitchKey = formObjectKeys.filter(
          k => {
            return (fields[name][k].productType === typeSwitch &&
              fields[name][k].name === poeSwitchIncludedEquipment)
          });
        const additionalEquipmentPoeCameraArray = [poeTurretCameraFree, poeTurretCamera, easyPoeTurret];
        if (additionalEquipmentPoeCameraArray.includes(fieldName) && value > 0) {
          const radioSelection = name.slice(0, 7);
          if (radioSelection === 'protect') {
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = true;
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 1;
          }
          if (radioSelection === 'control') {
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = true;
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 1; // this code is showing poeswitch in included eqp
          }
        }
        // Temperature Probe Visiblity
        const additionalEquipmentTempSensorArray = [temperatureSensor, easyTemperatureSensor,easyFiveYearTemperatureSensor];
        if (additionalEquipmentTempSensorArray.includes(fieldName) && value > 0) {
          const radioSelection = name.slice(0, 7);
          if (radioSelection === 'protect') {
            fields[keyProtectAdditionalEquipment].temperatureProbe.isVisible = true;
            fields[keyProtectAdditionalEquipment].temperatureProbe.value = value;
          }
          if (radioSelection === 'control') {
            fields[keyControlAdditionalEquipment].temperatureProbe.isVisible = true;
            fields[keyControlAdditionalEquipment].temperatureProbe.value = value;
          }
          if (radioSelection === 'monitor') {
            fields[keyMonitorAdditionalEquipment].temperatureProbe.isVisible = true;
            fields[keyMonitorAdditionalEquipment].temperatureProbe.value = value;
          }
        }
        if ((additionalEquipmentTempSensorArray.includes(fieldName)) && value < 1) {
          const radioSelection = name.slice(0, 7);
          if (radioSelection === 'protect') {
            fields[keyProtectAdditionalEquipment].temperatureProbe.isVisible = false;
            fields[keyProtectAdditionalEquipment].temperatureProbe.value = 0;
          }
          if (radioSelection === 'control') {
            fields[keyControlAdditionalEquipment].temperatureProbe.isVisible = false;
            fields[keyControlAdditionalEquipment].temperatureProbe.value = 0;
          }
          if (radioSelection === 'monitor') {
            fields[keyMonitorAdditionalEquipment].temperatureProbe.isVisible = false;
            fields[keyMonitorAdditionalEquipment].temperatureProbe.value = 0;
          }
        }
        if (includedSwitchKey.length > 0) {
          const hidePoeIncludedCamera = checkAllPoeCameraValues();
          if (!hidePoeIncludedCamera) {
            for (let i = 0; i < includedSwitchKey.length; i++) {
              fields[name][includedSwitchKey[i]].isVisible = poeCameraCount > 0;
              fields[name][includedSwitchKey[i]].value = poeCameraCount > 0 ? 1 : 0;
            }
          }
          if (poeCameraCount + getCameraTotal(fieldProductType, undefined, true, undefined) >= 5) {
            fields[secureBusinessOppositeSectionKeys[name]][fieldEasyPoeSwitchNonZero].isVisible = true;
            fields[secureBusinessOppositeSectionKeys[name]][fieldEasyPoeSwitchNonZero].value = 1;
          }
          if (poeCameraCount + getCameraTotal(fieldProductType, undefined, undefined, true) >= 5) {
            fields[secureBusinessOppositeSectionKeys[name]][fieldPoeSwitchNonZero].isVisible = true;
            fields[secureBusinessOppositeSectionKeys[name]][fieldPoeSwitchNonZero].value = 1;
          }
          if (poeCameraCount + getCameraTotal(fieldProductType, undefined, true, undefined) < 5) {
            fields[secureBusinessOppositeSectionKeys[name]][fieldEasyPoeSwitchNonZero].isVisible = undefined;
            fields[secureBusinessOppositeSectionKeys[name]][fieldEasyPoeSwitchNonZero].value = 0;
          }
          if (poeCameraCount + getCameraTotal(fieldProductType, undefined, undefined, true) < 5) {
            fields[secureBusinessOppositeSectionKeys[name]][fieldPoeSwitchNonZero].isVisible = undefined;
            fields[secureBusinessOppositeSectionKeys[name]][fieldPoeSwitchNonZero].value = 0;
          }
        }
        const switchKeyNonZero = formObjectKeys.filter(
          k => {
            return (fields[name][k].productType === typeSwitch &&
              fields[name][k].name === poeSwitchNonZero)
          });
        if (switchKeyNonZero.length > 0) {
          for (let i = 0; i < switchKeyNonZero.length; i++) {
            fields[name][switchKeyNonZero[i]].isVisible = (poeCameraCount + getCameraTotal(
              fieldProductType, true, undefined, undefined)) > 4;
            fields[name][switchKeyNonZero[i]].value = (poeCameraCount + getCameraTotal(
              fieldProductType, true, undefined, undefined)) > 4 ? 1 : 0;
          }
        }
        const radioSelection = name.slice(0, 7);
        const hidePoeIncludedCamera = checkAllPoeCameraValues();
        if (!hidePoeIncludedCamera) {
          if (radioSelection === 'protect') {
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = false;
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 0;
          }
          if (radioSelection === 'control') {
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = false;
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 0;
          }
        }

         // 2TB SVR addition with Poe Turret Camera
         if ([poeTurretCameraFree].includes(fieldName)) {
            const radioSelection = name.slice(0, 7);
  
            if (radioSelection === 'control') {
              if (value > 0) {
                fields[
                  keyControlIncludedEquipmentSelection
                ].controlIncludedPaid2TbSvr.value = 1;
                fields[
                    keyControlIncludedEquipmentSelection
                ].controlIncludedPaid2TbSvr.isVisible = true;
              } 
              else if((value === 0 || value !== 0 ) && poeCameraCountAll === 0) {
                fields[
                    keyControlIncludedEquipmentSelection
                ].controlIncludedPaid2TbSvr.value = 0;  
              }
            }
          }
           // Adding SD Card equal qty to indoor/outdoor camera
        // if turret camera is added then sd cards are not added,
        // if no turret camera thenf sd cards are added with indoor/outdoor control camera

        if (
            [
              indoorCameraFree,
              outdoorCameraFree,
              poeTurretCameraFree
            ].includes(fieldName)
          ) {
            setSdCard(fields);
          }


            // add  sd card to additional control equipment 
        if (
            [
              indoorCamera,outdoorCamera,poeTurretCameraFree
            ].includes(fieldName)
          ) {
            const controlIncludedPoeTurretCameraValue =
              fields[keyControlIncludedEquipmentSelection]
                .controlIncludedPaid2TbSvr.value;
            const radioSelection = name.slice(0, 7);
            if (radioSelection === 'control') {
              const cameraSum =
                parseInt(
                  fields[keyControlAdditionalEquipment]
                    .indoorCamera.value || 0,
                  10
                ) +
                parseInt(
                  fields[keyControlAdditionalEquipment]
                    .outdoorCamera.value || 0,
                  10
                );

              if (cameraSum > 0 && !(controlIncludedPoeTurretCameraValue >= 1)) {
                fields[
                  keyControlAdditionalEquipment
                ].microSdCard128Gb.value = cameraSum;
              } else if (
                cameraSum === 0 ||
                controlIncludedPoeTurretCameraValue >= 1
              ) {
                fields[
                    keyControlAdditionalEquipment
                ].microSdCard128Gb.value = 0;
              }
            }
          } 
          // Resetting Five Year fields as per turretCamera Selection  
          if (
            [
              easyFiveYearIndoorCamera,easyFiveYearOutdoorCamera,poeTurretCameraFree
            ].includes(fieldName)
          ) {
            const controlIncludedPoeTurretCameraValue =
              fields[keyControlIncludedEquipmentSelection]
                .controlIncludedPaid2TbSvr.value;
            const radioSelection = name.slice(0, 7);
  
            if (radioSelection === 'control') {
              const cameraSum =
                parseInt(
                  fields[keyControlAdditionalEquipment]
                    .easyFiveYearIndoorCamera.value || 0,
                  10
                ) +
                parseInt(
                  fields[keyControlAdditionalEquipment]
                    .easyFiveYearOutdoorCamera.value || 0,
                  10
                );
              if (cameraSum > 0 && !(controlIncludedPoeTurretCameraValue >= 1)) {
                fields[
                  keyControlAdditionalEquipment
                ].easyFiveYearMicroSdCard128Gb.value = cameraSum;
              } else if (
                cameraSum === 0 ||
                controlIncludedPoeTurretCameraValue >= 1
              ) {
                fields[
                    keyControlAdditionalEquipment
                ].easyFiveYearMicroSdCard128Gb.value = 0;
              }
            }
          }  
           // Resetting Three Year fields as per turretCamera Selection  
           if (
            [
              easyIndoorCamera,easyOutdoorCamera,poeTurretCameraFree
            ].includes(fieldName)
          ) {
            const controlIncludedPoeTurretCameraValue =
              fields[keyControlIncludedEquipmentSelection]
                .controlIncludedPaid2TbSvr.value;
            const radioSelection = name.slice(0, 7);
  
            if (radioSelection === 'control') {
              const cameraSum =
                parseInt(
                  fields[keyControlAdditionalEquipment]
                    .easyIndoorCamera.value || 0,
                  10
                ) +
                parseInt(
                  fields[keyControlAdditionalEquipment]
                    .easyOutdoorCamera.value || 0,
                  10
                );
              if (cameraSum > 0 && !(controlIncludedPoeTurretCameraValue >= 1)) {
                fields[
                  keyControlAdditionalEquipment
                ].easyMicroSdCard128Gb.value = cameraSum;
              } else if (
                cameraSum === 0 ||
                controlIncludedPoeTurretCameraValue >= 1
              ) {
                fields[
                    keyControlAdditionalEquipment
                ].easyMicroSdCard128Gb.value = 0;
              }
            }
          }  
          
      }
      else if (checkIfHasSwitchOption() && fieldName.startsWith('easyFiveYear')) {
        const poeCameraCount = formObjectKeys
          .filter(
            kc =>
              fields[name][kc].productType === typePoeCamera &&
              kc.startsWith('easyFiveYear')
          )
          .reduce(
            (acc, kc) => acc + parseInt(fields[name][kc].value || 0, 10),
            0
          );
        const switchKey = formObjectKeys.filter(
          k =>
          (fields[name][k].productType === typeSwitch &&
            fields[name][k].name === fieldEasyFiveYearFivePortPoeSwitch)
        );
        const additionalEquipmentPoeCameraArray = [, poeTurretCameraFree, poeTurretCamera, easyPoeTurret];
        if (additionalEquipmentPoeCameraArray.includes(fieldName) && value > 0) {
          const radioSelection = name.slice(0, 7);
          if (radioSelection === 'protect') {
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = true;
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 1;
          }
          if (radioSelection === 'control') {
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = true;
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 1;
          }
        }
        // Easy Temperature Probe Visible
        const additionalEquipmentTempSensorArray = [temperatureSensor, easyTemperatureSensor,easyFiveYearTemperatureSensor];
        if (additionalEquipmentTempSensorArray.includes(fieldName) && value > 0) {
          const radioSelection = name.slice(0, 7);
          if (radioSelection === 'protect') {
            fields[keyProtectAdditionalEquipment].easyFiveYearTemperatureProbe.isVisible = true;
            fields[keyProtectAdditionalEquipment].easyFiveYearTemperatureProbe.value = value;
          }
          if (radioSelection === 'control') {
            fields[keyControlAdditionalEquipment].easyFiveYearTemperatureProbe.isVisible = true;
            fields[keyControlAdditionalEquipment].easyFiveYearTemperatureProbe.value = value;
          }
          if (radioSelection === 'monitor') {
            fields[keyMonitorAdditionalEquipment].easyFiveYearTemperatureProbe.isVisible = true;
            fields[keyMonitorAdditionalEquipment].easyFiveYearTemperatureProbe.value = value;
          }
        }
        if ((additionalEquipmentTempSensorArray.includes(fieldName)) && value < 1) {
          const radioSelection = name.slice(0, 7);
          if (radioSelection === 'protect') {
            fields[keyProtectAdditionalEquipment].easyFiveYearTemperatureProbe.isVisible = false;
            fields[keyProtectAdditionalEquipment].easyFiveYearTemperatureProbe.value = 0;
          }
          if (radioSelection === 'control') {
            fields[keyControlAdditionalEquipment].easyFiveYearTemperatureProbe.isVisible = false;
            fields[keyControlAdditionalEquipment].easyFiveYearTemperatureProbe.value = 0;
          }
          if (radioSelection === 'monitor') {
            fields[keyMonitorAdditionalEquipment].easyFiveYearTemperatureProbe.isVisible = false;
            fields[keyMonitorAdditionalEquipment].easyFiveYearTemperatureProbe.value = 0;
          }
        }
        if (switchKey.length > 0) {
          for (let i = 0; i < switchKey.length; i++) {
            fields[name][switchKey[i]].isVisible = poeCameraCount > 0;
            fields[name][switchKey[i]].value = poeCameraCount > 0 ? 1 : 0;
        }
        fields[keyControlIncludedEquipmentSelection][controlIncludedPaid2TbSvr].value = poeCameraCountAll > 0 ? 1 : 0;
        setSdCard(fields);

        }
        const switchKeyNonZero = formObjectKeys.filter(
          k =>
          (fields[name][k].productType === typeSwitch &&
            fields[name][k].name === fieldEasyFiveYearFivePortPoeSwitchPaid)
        );
        if (switchKeyNonZero.length > 0) {
          for (let i = 0; i < switchKeyNonZero.length; i++) {
            fields[name][switchKeyNonZero[i]].isVisible = (poeCameraCount + getCameraTotal(
              fieldProductType, true, undefined, undefined)) > 4;
            fields[name][switchKeyNonZero[i]].value = (poeCameraCount + getCameraTotal(
              fieldProductType, true, undefined, undefined)) > 4 ? 1 : 0;
          }
        }
        const radioSelection = name.slice(0, 7);
        const hidePoeIncludedCamera = checkAllPoeCameraValues();
        if (!hidePoeIncludedCamera) {
          if (radioSelection === 'protect') {
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = false;
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 0;
          }
          if (radioSelection === 'control') {
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = false;
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 0;
          }
        }

        if (
            [
              easyFiveYearIndoorCamera,easyFiveYearOutdoorCamera,poeTurretCameraFree
            ].includes(fieldName)
          ) {
            const controlIncludedPoeTurretCameraValue =
              fields[keyControlIncludedEquipmentSelection]
                .controlIncludedPaid2TbSvr.value;
            const radioSelection = name.slice(0, 7);
  
            if (radioSelection === 'control') {
              const cameraSum =
                parseInt(
                  fields[keyControlAdditionalEquipment]
                    .easyFiveYearIndoorCamera.value || 0,
                  10
                ) +
                parseInt(
                  fields[keyControlAdditionalEquipment]
                    .easyFiveYearOutdoorCamera.value || 0,
                  10
                );
              if (cameraSum > 0 && !(controlIncludedPoeTurretCameraValue >= 1)) {
                fields[
                  keyControlAdditionalEquipment
                ].easyFiveYearMicroSdCard128Gb.value = cameraSum;
              } else if (
                cameraSum === 0 ||
                controlIncludedPoeTurretCameraValue >= 1
              ) {
                fields[
                    keyControlAdditionalEquipment
                ].easyFiveYearMicroSdCard128Gb.value = 0;
              }
            }
          }
      }
       else if (checkIfHasSwitchOption() && fieldName.startsWith('easy')) {
        const poeCameraCount = formObjectKeys
          .filter(
            kc =>
              fields[name][kc].productType === typePoeCamera &&
              kc.startsWith('easy')
          )
          .reduce(
            (acc, kc) => acc + parseInt(fields[name][kc].value || 0, 10),
            0
          );
        const switchKey = formObjectKeys.filter(
          k =>
          (fields[name][k].productType === typeSwitch &&
            fields[name][k].name === easyPoeSwitchZero)
        );
        const additionalEquipmentPoeCameraArray = [, poeTurretCameraFree, poeTurretCamera, easyPoeTurret];
        if (additionalEquipmentPoeCameraArray.includes(fieldName) && value > 0) {
          const radioSelection = name.slice(0, 7);
          if (radioSelection === 'protect') {
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = true;
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 1;
          }
          if (radioSelection === 'control') {
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = true;
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 1;
          }
        }
        // Easy Temperature Probe Visible
        const additionalEquipmentTempSensorArray = [temperatureSensor, easyTemperatureSensor];
        if (additionalEquipmentTempSensorArray.includes(fieldName) && value > 0) {
          const radioSelection = name.slice(0, 7);
          if (radioSelection === 'protect') {
            fields[keyProtectAdditionalEquipment].easyTemperatureProbe.isVisible = true;
            fields[keyProtectAdditionalEquipment].easyTemperatureProbe.value = value;
          }
          if (radioSelection === 'control') {
            fields[keyControlAdditionalEquipment].easyTemperatureProbe.isVisible = true;
            fields[keyControlAdditionalEquipment].easyTemperatureProbe.value = value;
          }
          if (radioSelection === 'monitor') {
            fields[keyMonitorAdditionalEquipment].easyTemperatureProbe.isVisible = true;
            fields[keyMonitorAdditionalEquipment].easyTemperatureProbe.value = value;
          }
        }
        if ((additionalEquipmentTempSensorArray.includes(fieldName)) && value < 1) {
          const radioSelection = name.slice(0, 7);
          if (radioSelection === 'protect') {
            fields[keyProtectAdditionalEquipment].easyTemperatureProbe.isVisible = false;
            fields[keyProtectAdditionalEquipment].easyTemperatureProbe.value = 0;
          }
          if (radioSelection === 'control') {
            fields[keyControlAdditionalEquipment].easyTemperatureProbe.isVisible = false;
            fields[keyControlAdditionalEquipment].easyTemperatureProbe.value = 0;
          }
          if (radioSelection === 'monitor') {
            fields[keyMonitorAdditionalEquipment].easyTemperatureProbe.isVisible = false;
            fields[keyMonitorAdditionalEquipment].easyTemperatureProbe.value = 0;
          }
        }
        if (switchKey.length > 0) {
          for (let i = 0; i < switchKey.length; i++) {
            fields[name][switchKey[i]].isVisible = poeCameraCount > 0;
            fields[name][switchKey[i]].value = poeCameraCount > 0 ? 1 : 0;
        }
        fields[keyControlIncludedEquipmentSelection][controlIncludedPaid2TbSvr].value = poeCameraCountAll > 0 ? 1 : 0;
        setSdCard(fields);

        }
        const switchKeyNonZero = formObjectKeys.filter(
          k =>
          (fields[name][k].productType === typeSwitch &&
            fields[name][k].name === easyPoeSwitchNonZero)
        );
        if (switchKeyNonZero.length > 0) {
          for (let i = 0; i < switchKeyNonZero.length; i++) {
            fields[name][switchKeyNonZero[i]].isVisible = (poeCameraCount + getCameraTotal(
              fieldProductType, true, undefined, undefined)) > 4;
            fields[name][switchKeyNonZero[i]].value = (poeCameraCount + getCameraTotal(
              fieldProductType, true, undefined, undefined)) > 4 ? 1 : 0;
          }
        }
        const radioSelection = name.slice(0, 7);
        const hidePoeIncludedCamera = checkAllPoeCameraValues();
        if (!hidePoeIncludedCamera) {
          if (radioSelection === 'protect') {
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = false;
            fields[keyProtectIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 0;
          }
          if (radioSelection === 'control') {
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.isVisible = false;
            fields[keyControlIncludedEquipmentSelection].poeSwitchIncludedEquipment.value = 0;
          }
        }

         // Setting Three Year fields as per turretCamera Selection  
         if (
            [
              easyIndoorCamera,easyOutdoorCamera,poeTurretCameraFree
            ].includes(fieldName)
          ) {
            const controlIncludedPoeTurretCameraValue =
              fields[keyControlIncludedEquipmentSelection]
                .controlIncludedPaid2TbSvr.value;
            const radioSelection = name.slice(0, 7);
  
            if (radioSelection === 'control') {
              const cameraSum =
                parseInt(
                  fields[keyControlAdditionalEquipment]
                    .easyIndoorCamera.value || 0,
                  10
                ) +
                parseInt(
                  fields[keyControlAdditionalEquipment]
                    .easyOutdoorCamera.value || 0,
                  10
                );
              if (cameraSum > 0 && !(controlIncludedPoeTurretCameraValue >= 1)) {
                fields[
                  keyControlAdditionalEquipment
                ].easyMicroSdCard128Gb.value = cameraSum;
              } else if (
                cameraSum === 0 ||
                controlIncludedPoeTurretCameraValue >= 1
              ) {
                fields[
                    keyControlAdditionalEquipment
                ].easyMicroSdCard128Gb.value = 0;
              }
            }
          }  
      }
      if (
        [
        keyControlIncludedEquipmentSelection,
          keyControlAdditionalEquipment,
          keyProtectAdditionalEquipment,
          keyMonitorAdditionalEquipment,
          keySecurityCameraEquipment
        ].includes(name)
      ) {
        calculateEquipmentRates(oldValues, fields[name], fieldName,oldFields,fields);
      }
      setFormFields(fields);
    }
  };

  const countPoeCameras = (key) => {
    let poeCameraCount = 0;
    const radioSelection = name.slice(0, 7);
    if (radioSelection === 'protect') {
      if (key === 'onetimePayment') {
        poeCameraCount =
          (formFields[keyProtectIncludedEquipmentSelection][poeTurretCameraFree].value !== undefined ?
            formFields[keyProtectIncludedEquipmentSelection][poeTurretCameraFree].value : 0) +
          (formFields[keyProtectAdditionalEquipment][poeTurretCamera].value !== undefined ?
            formFields[keyProtectAdditionalEquipment][poeTurretCamera].value : 0);
      }
      if (key === 'easyPayment') {
        poeCameraCount =
          (formFields[keyProtectIncludedEquipmentSelection][poeTurretCameraFree].value !== undefined ?
            formFields[keyProtectIncludedEquipmentSelection][poeTurretCameraFree].value : 0) +
          (formFields[keyProtectAdditionalEquipment][easyPoeTurret].value !== undefined ?
            formFields[keyProtectAdditionalEquipment][easyPoeTurret].value : 0);
      }
    }
    else if (radioSelection === 'control') {
      if (key === 'onetimePayment') {
        poeCameraCount =
          
          (formFields[keyControlIncludedEquipmentSelection][poeTurretCameraFree].value !== undefined ?
            formFields[keyControlIncludedEquipmentSelection][poeTurretCameraFree].value : 0) +
          (formFields[keyControlAdditionalEquipment][poeTurretCamera].value !== undefined ?
            formFields[keyControlAdditionalEquipment][poeTurretCamera].value : 0);
      }
      if (key === 'easyPayment') {
       
          (formFields[keyControlIncludedEquipmentSelection][poeTurretCameraFree].value !== undefined ?
            formFields[keyControlIncludedEquipmentSelection][poeTurretCameraFree].value : 0) +
          
          (formFields[keyControlAdditionalEquipment][easyPoeTurret].value !== undefined ?
            formFields[keyControlAdditionalEquipment][easyPoeTurret].value : 0);
      }
    }
    return poeCameraCount;
  }

  const countTemperatureSensor = (key) => {
    let tempSensorCount = 0;
    const radioSelection = name.slice(0, 7);

    if (radioSelection === 'monitor') {
      if (key === 'onetimePayment') {
        tempSensorCount =
          formFields[keyMonitorAdditionalEquipment][temperatureSensor].value !== undefined ?
            formFields[keyMonitorAdditionalEquipment][temperatureSensor].value : 0
      }
      if (key === 'easyPayment') {
        tempSensorCount =
          formFields[keyMonitorAdditionalEquipment][easyTemperatureSensor].value !== undefined ?
            formFields[keyMonitorAdditionalEquipment][easyTemperatureSensor].value : 0
      }
      if (key === 'fiveYearEasyPayment') {
        tempSensorCount =
          formFields[keyMonitorAdditionalEquipment][easyFiveYearTemperatureSensor].value !== undefined ?
            formFields[keyMonitorAdditionalEquipment][easyFiveYearTemperatureSensor].value : 0
      }
    }
    if (radioSelection === 'protect') {
      if (key === 'onetimePayment') {
        tempSensorCount =
          formFields[keyProtectAdditionalEquipment][temperatureSensor].value !== undefined ?
            formFields[keyProtectAdditionalEquipment][temperatureSensor].value : 0
      }
      if (key === 'easyPayment') {
        tempSensorCount =
          formFields[keyProtectAdditionalEquipment][easyTemperatureSensor].value !== undefined ?
            formFields[keyProtectAdditionalEquipment][easyTemperatureSensor].value : 0
      }
      if (key === 'fiveYearEasyPayment') {
        tempSensorCount =
          formFields[keyProtectAdditionalEquipment][easyFiveYearTemperatureSensor].value !== undefined ?
            formFields[keyProtectAdditionalEquipment][easyFiveYearTemperatureSensor].value : 0
      }
    }
    if (radioSelection === 'control') {
      if (key === 'onetimePayment') {
        tempSensorCount =
          formFields[keyControlAdditionalEquipment][temperatureSensor].value !== undefined ?
            formFields[keyControlAdditionalEquipment][temperatureSensor].value : 0
      }
      if (key === 'easyPayment') {
        tempSensorCount =
          formFields[keyControlAdditionalEquipment][easyTemperatureSensor].value !== undefined ?
            formFields[keyControlAdditionalEquipment][easyTemperatureSensor].value : 0
      }
      if (key === 'fiveYearEasyPayment') {
        tempSensorCount =
          formFields[keyControlAdditionalEquipment][easyFiveYearTemperatureSensor].value !== undefined ?
            formFields[keyControlAdditionalEquipment][easyFiveYearTemperatureSensor].value : 0
      }
    }
    return tempSensorCount;
  }

  const selectedProvince = localStorage.getItem('province');
  const history = useHistory();
  const currentPath = history.location.pathname.split('/')[3];
  return (
    <>
      {subTitle && <EquipmentSectionTitle>{subTitle}</EquipmentSectionTitle>}
      {title && <EquipmentSectionTitle>{title}</EquipmentSectionTitle>}
      <div style={{ display: 'flex' }}>
        <EquipmentSectionWrapper>
          {oneTimePaymentTitle && (
            <EquipmentSectionSubTitle>
              {oneTimePaymentTitle}
            </EquipmentSectionSubTitle>
          )}
          {formFields[name] &&
            formStepFields.map(({ fields, sys: { id: sysId } }, index) => {
              const key = `EquipmentSection${name}${index}`;
              const error = formErrors[name] && formErrors[name][fields.name];
              const hiddenValue = checkIfHasSwitchOption()
                ? !formFields[name][fields.name].isVisible || formFields[name][fields.name].isHidden
                : false;
              // SOF-1582: Non-zero value for POE switch should not be visible
              const poeCameraCount = countPoeCameras('onetimePayment');
              if (currentPath === 'Order_Details' && formFields[name][poeSwitchNonZero] && poeCameraCount < 5) {
                formFields[name][poeSwitchNonZero].isVisible = false;
              }

              const temperatureSensorCount = countTemperatureSensor('onetimePayment');
              if ((currentPath === 'Quote_tool' || currentPath === 'Order_Details') &&
                formFields[name][temperatureProbe] && temperatureSensorCount < 1) {
                formFields[name][temperatureProbe].isVisible = false;
              }
              const fieldData = {
                ...fields,
                ...formFields[name][fields.name],
                isHidden: hiddenValue,
                formFields,
                sysId,
                onChange: e => handleFormField(e.target)
              };
              return (
                <Fragment key={key}>
                  <FormField data={fieldData} />
                  {error && error.text && <Error text={error.text} />}
                </Fragment>
              );
            })}
        </EquipmentSectionWrapper>

        {/* 
        Easy Payments are shown/hidden based on boolean value of shouldHideEasyPayments
      */}
        {(
          <EquipmentSectionWrapper>
            {easyPaymentTitle && (
              <EquipmentSectionSubTitle>
                {easyPaymentTitle}
              </EquipmentSectionSubTitle>
            )}
            {formFields[name] &&
              Array.isArray(easyPaymentFields) &&
              easyPaymentFields.map(({ fields, sys: { id: sysId } }, index) => {
                const key = `EquipmentSection${name}${index}`;
                const error = formErrors[name] && formErrors[name][fields.name];
                const hiddenValue = checkIfHasSwitchOption()
                  ? !formFields[name][fields.name].isVisible || formFields[name][fields.name].isHidden
                  : false;
                // SOF-1582: Non-zero value for POE switch should not be visible
                const poeCameraCount = countPoeCameras('easyPayment');
                if (currentPath === 'Order_Details' && formFields[name][easyPoeSwitchNonZero] && poeCameraCount < 5) {
                  formFields[name][easyPoeSwitchNonZero].isVisible = false;
                }
                const temperatureSensorCount = countTemperatureSensor('easyPayment')
                if ((currentPath === 'Quote_tool' || currentPath === 'Order_Details') &&
                  formFields[name][easyTemperatureProbe] && temperatureSensorCount < 1) {
                  formFields[name][easyTemperatureProbe].isVisible = false;
                }
                
                const fieldData = {
                  ...fields,
                  ...formFields[name][fields.name],
                  isHidden: hiddenValue,
                  formFields,
                  sysId,
                  onChange: e => handleFormField(e.target)
                };
                return (
                  <Fragment key={key}>
                    <FormField data={fieldData} />
                    {error && error.text && <Error text={error.text} />}
                  </Fragment>
                );
              })}
          </EquipmentSectionWrapper>
        )}

        {/* show five year payment fields */}
        {(
          <EquipmentSectionWrapper>
            {fiveYearEasyPaymentTitle && (
              <EquipmentSectionSubTitle>
                {fiveYearEasyPaymentTitle}
              </EquipmentSectionSubTitle>
            )}
            {formFields[name] &&
              Array.isArray(fiveYearEasyPaymentFields) &&
              fiveYearEasyPaymentFields.map(({ fields, sys: { id: sysId } }, index) => {
                const key = `EquipmentSection${name}${index}`;
                const error = formErrors[name] && formErrors[name][fields.name];
                const hiddenValue = checkIfHasSwitchOption()
                  ? !formFields[name][fields.name].isVisible || formFields[name][fields.name].isHidden
                  : false;
                // SOF-1582: Non-zero value for POE switch should not be visible
                const poeCameraCount = countPoeCameras('easyPayment');
                if (currentPath === 'Order_Details' && formFields[name][easyPoeSwitchNonZero] && poeCameraCount < 5) {
                  formFields[name][easyPoeSwitchNonZero].isVisible = false;
                }
                const easyFiveYearTemperatureSensorCount = countTemperatureSensor('fiveYearEasyPayment');
                if ((currentPath === 'Quote_tool' || currentPath === 'Order_Details') &&
                  formFields[name][easyFiveYearTemperatureProbe] && easyFiveYearTemperatureSensorCount < 1) {
                  formFields[name][easyFiveYearTemperatureProbe].isVisible = false;
                }
                const fieldData = {
                  ...fields,
                  ...formFields[name][fields.name],
                  isHidden: hiddenValue,
                  formFields,
                  sysId,
                  onChange: e => handleFormField(e.target)
                };
                return (
                  <Fragment key={key}>
                    <FormField data={fieldData} />
                    {error && error.text && <Error text={error.text} />}
                  </Fragment>
                );
              })}
          </EquipmentSectionWrapper>
        )}

      </div>
      <Modal
        heading={"Alert"}
        isOpen={isAlert}
        bodyText={bodyText}
        onClose={() => setIsAlertOpen(false)}
        />
    </>
  );
};

EquipmentSectionForm.propTypes = {
  data: PropTypes.shape({
    formStepFields: PropTypes.arrayOf(PropTypes.object),
    easyPaymentFields: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string,
    subTitle: PropTypes.string,
    maxValue: PropTypes.number,
    isLimitCameraOnly: PropTypes.bool,
    name: PropTypes.string.isRequired,
    oneTimePaymentTitle: PropTypes.string.isRequired,
    easyPaymentTitle: PropTypes.string.isRequired
  }).isRequired,
  formErrors: PropTypes.objectOf(PropTypes.object),
  formFields: PropTypes.objectOf(PropTypes.object).isRequired,
  setFormFields: PropTypes.func.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  setIsFormTouched: PropTypes.func.isRequired,
  equipmentTotalPrice: PropTypes.shape({
    subtractAmountFromPrice: PropTypes.number.isRequired,
    addAmountToPrice: PropTypes.number.isRequired,
    addAmountToMonthly: PropTypes.number.isRequired,
    monthlyPayment: PropTypes.number.isRequired,
    addAmountToFiveYearMonthly: PropTypes.number.isRequired,
    subtractAmountFromFiveYearMonthly : PropTypes.number.isRequired
  }).isRequired,
  setEquipmentTotalPrice: PropTypes.func.isRequired,
  hardwareDiscountAmount: PropTypes.number.isRequired,
  setHadwareDiscountAmount: PropTypes.func.isRequired,
  dueNow: PropTypes.number.isRequired,
  setDueNow: PropTypes.func.isRequired,
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  isHardwareDiscount: PropTypes.func.isRequired
};

EquipmentSectionForm.defaultProps = {
  formErrors: {}
};

export default EquipmentSectionForm;
